import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
};

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    setPatients: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setPatients } = patientsSlice.actions;

export const PatientsReducer = patientsSlice.reducer;
